export default {
  pageTitle: 'Big-screen lottery',
  pageDesc: 'From QR check-in to the lucky reveal, make every guest part of the show.',
  backToList: 'Back to activity list',
  list: {
    description: 'Select a lottery activity to manage its live draw, prizes, page design, and participants.',
    create: 'Create lottery activity',
    count: 'Lottery activities',
    search: 'Search activity name',
    name: 'Activity name',
    prizes: 'Prizes',
    prizeUnit: 'items',
    participants: 'Participants',
    peopleUnit: 'people',
    winners: 'Winners',
    status: 'Status',
    actions: 'Actions',
    enter: 'Enter activity',
    participantList: 'Participants',
    winnerList: 'Winners',
    namePlaceholder: 'Enter lottery activity name',
    nameRequired: 'Enter a lottery activity name',
    createTitle: 'Create lottery activity',
    createSuccess: 'Lottery activity created',
    empty: 'No lottery activities yet. Create one to get started.',
    active: 'In progress',
    pending: 'Not started',
    disabled: 'Disabled',
    loadFailed: 'Failed to load lottery activities'
  },
  createForm: {
    title: 'Main title',
    subtitle: 'Subtitle',
    titlePlaceholder: 'e.g. 2026 Annual Gala Lucky Draw',
    subtitlePlaceholder: 'e.g. Together today, luck all the way',
    prizeConfig: 'Prize setup',
    prizeConfigDesc: 'Prizes are drawn in this order. Use transparent 1:1 PNG images up to 2 MB.',
    prizeLevel: 'Prize level',
    giftName: 'Prize name',
    prizeImage: 'Prize image (1:1)',
    winnerSlots: 'Winner slots',
    prizeLevelPlaceholder: 'Prize level',
    giftNamePlaceholder: 'Prize name',
    dragToSort: 'Drag to reorder prizes',
    uploadImage: 'Upload image',
    removeImage: 'Remove image',
    imageHint: 'Upload or replace the prize image. A transparent 1:1 PNG is recommended.',
    delete: 'Delete',
    addPrize: 'Add prize',
    createAndEnter: 'Create and enter',
    titleRequired: 'Enter a main title',
    prizeRequired: 'Add at least one prize',
    prizeFieldsRequired: 'Complete both the prize level and prize name',
    imageTypeError: 'Only PNG, JPG, and WebP images are supported',
    imageSizeError: 'Each prize image must be 2 MB or smaller',
    imageUploadFailed: 'The activity was created, but some prize images failed to upload. Update them in the activity.',
    partialCreated: 'The activity was created, but some settings were not saved. Check and complete them in the activity.',
    createFailed: 'Unable to create the lottery activity. Please try again.',
    defaultLevel: 'Lucky prize',
    defaultGift: 'Event gift box',
    defaultSpecialLevel: 'Special prize',
    defaultSpecialGift: 'Commemorative gift'
  },
  openParticipant: 'Open participant page',
  openScreen: 'Open lottery screen',
  copyScreenLink: 'Copy lottery screen link',
  screenLinkCopied: 'Lottery screen link copied',
  screenLinkCopyFailed: 'Copy failed. Select and copy the link manually.',
  reset: {
    activity: 'Reset activity',
    winners: 'Reset winners',
    activityTitle: 'Confirm reset and start the next session',
    winnersTitle: 'Confirm winner reset',
    activityWarning: 'This ends the current session and starts a new one. Past participants and winner records are kept, fixed prizes are cleared; WeChat-authorized participants who did not win continue automatically, and imported participants marked as multi-session continue if they did not win.',
    winnersWarning: 'Winner records in the current session will be cleared. Participants and prize configuration will be kept.',
    captchaPlaceholder: 'Enter verification code',
    refreshCaptcha: 'Click to refresh the verification code',
    captchaRequired: 'Enter the verification code',
    captchaLoadFailed: 'Unable to load the verification code. Please try again.',
    confirm: 'Reset',
    resetting: 'Resetting…',
    activitySuccess: 'The next session has started',
    winnersSuccess: 'Winner records reset',
    notReady: 'All prizes must be drawn before resetting'
  },
  loading: 'Loading lottery configuration…',
  loadFailed: 'Unable to load lottery configuration',
  save: 'Save configuration',
  saving: 'Saving…',
  saveSuccess: 'Big-screen lottery configuration saved',
  tabs: {
    console: 'Console',
    prizes: 'Prizes & rules',
    design: 'Screen design',
    participants: 'Participants',
    winners: 'Winners'
  },
  console: {
    title: 'Draw console',
    desc: 'Operators control draw rounds, reveal timing, and the screen QR code here.',
    liveControl: 'Live control',
    screenPreview: 'Live lottery screen preview',
    openParticipation: 'Open participation',
    closeParticipation: 'End participation',
    scanJoin: 'Scan to join the draw',
    scanHint: 'Scan with WeChat and authorize to participate',
    roundPrize: 'Prize for this round',
    winnerUnit: 'winners',
    notDrawn: 'Not drawn',
    waiting: 'Waiting',
    operatorMode: 'Operator mode',
    currentRound: 'Current round',
    noRound: 'Not started',
    participants: 'Participants',
    readyForDraw: 'eligible guests',
    currentPrize: 'Current prize',
    prizePlaceholder: 'Choose a prize for this round',
    start: 'Start draw',
    roll: 'Start draw',
    finish: 'Stop and reveal',
    cancel: 'Cancel round',
    controlHint: 'Changes are synchronized to the lottery screen immediately. Confirm the venue is ready before operating.',
    qrTitle: 'Screen QR code',
    qrEnabled: 'QR code visible',
    qrDisabled: 'QR code hidden',
    qrEnabledHint: 'Guests can continue scanning to join the draw.',
    qrDisabledHint: 'The participation QR code is hidden and replaced by the winner-result QR code. Joined participants are unchanged.',
    qrShown: 'Screen QR code is now visible',
    qrHidden: 'Screen QR code hidden'
  },
  stats: {
    signed: 'Checked in',
    signedGuests: 'Checked-in guests',
    participants: 'Joined',
    winners: 'Winners',
    cumulativeWinners: 'Total winners',
    unit: ''
  },
  prizes: {
    fallbackLevel: 'Prize {index}',
    title: 'Prizes and winner slots',
    desc: 'Prizes are drawn in configured order with the number of winners set for each round. Transparent 1:1 PNG images up to 2 MB are recommended.',
    enabled: 'Enable big-screen lottery',
    level: 'Prize level',
    name: 'Prize name',
    image: 'Prize image (1:1)',
    quantity: 'Winners per round',
    fixedWinner: 'Fixed winner',
    fixedWinnerMobile: 'Set from the participant list',
    actions: 'Actions',
    levelPlaceholder: 'e.g. Lucky prize',
    namePlaceholder: 'e.g. Event gift box',
    add: 'Add prize',
    delete: 'Remove',
    dragToSort: 'Drag to reorder prizes',
    uploadImage: 'Upload image',
    removeImage: 'Remove image',
    imageHint: 'Upload or replace the prize image. A transparent 1:1 PNG is recommended.',
    imageTypeError: 'Only PNG, JPG, and WebP images are supported',
    imageSizeError: 'Each prize image must be 2 MB or smaller',
    imageUploadFailed: 'Unable to upload the prize image. Please try again.',
    noRepeatHint: 'Each guest can win only once in this activity. Previous winners are excluded automatically.',
    empty: 'No prizes yet. Add a prize to begin.',
    completePrize: 'Complete the prize level, prize name, and winner slots',
    fixedWinnerOverLimit: '“{name}” allows at most {count} fixed winner(s). Reduce the fixed winners or increase the winner slots.',
    deleteConfirm: 'Remove “{name}”? Existing winner records will be kept.',
    participationDuration: 'Join window (seconds)',
    participationDurationHint: '180 seconds by default. Guests must join before the countdown ends.',
    rollDuration: 'Rolling duration (seconds)',
    rollDurationHint: 'Rolling starts when the join window closes and reveals winners when time is up.',
    repeatWinner: 'Allow the same guest to win in different rounds',
    screenTitle: 'Screen title',
    screenSubtitle: 'Screen subtitle',
    screenSettings: 'Screen display',
    theme: 'Screen theme',
    themes: {
      gold: 'Midnight gold',
      red: 'Chinese red',
      blue: 'Tech blue'
    },
    currentRound: 'Current round',
    noRound: 'No draw started yet',
    nextPrize: 'Up next',
    startRound: 'Start round',
    rollNow: 'Roll now',
    finishNow: 'Reveal now',
    cancelRound: 'Cancel round',
    status: {
      joining: 'Joining',
      rolling: 'Rolling',
      finished: 'Finished',
      cancelled: 'Cancelled'
    }
  },
  design: {
    title: 'Screen page design',
    mainTitle: 'Main title',
    mainTitlePlaceholder: 'Enter the main screen title',
    subtitle: 'Subtitle',
    subtitlePlaceholder: 'Enter the screen subtitle',
    stageBackground: 'Stage background',
    stageBackgroundHint: 'Choose a built-in background or upload your own image. The background fills the screen automatically, so keep important content near the edges.',
    backgrounds: {
      gold: { name: 'Golden starlight', desc: 'Golden beams · Annual gala' },
      red: { name: 'Crimson curtain', desc: 'Red silk · Festive draw' },
      blue: { name: 'Aurora galaxy', desc: 'Blue halos · Tech gala' }
    },
    customBackground: 'Custom background',
    customBackgroundHint: 'JPG / PNG / WebP, up to 5 MB. 1920 × 1080 recommended; saved to cloud storage after upload.',
    uploadBackground: 'Upload background',
    logo: 'Event logo',
    uploadImage: 'Upload image',
    remove: 'Remove',
    logoHint: 'Up to 5 MB; transparent PNG supported',
    uploadedImage: 'Uploaded image',
    backgroundMusic: 'Background music',
    backgroundMusicHint: 'MP3 / WAV / OGG, up to 10 MB. The built-in music is used when none is uploaded or after removal.',
    defaultMusic: 'Default background music',
    uploadMusic: 'Upload music',
    musicTypeError: 'Only MP3, WAV, or OGG audio is supported',
    musicSizeError: 'Audio file cannot exceed 10 MB',
    joinCopy: 'Check-in success copy',
    successText: 'Success message',
    blessing: 'Blessing',
    sound: 'Enable background music and draw sound (tap the screen to enable audio)',
    autoReturn: 'Auto return to lottery home after winning',
    autoReturnHint: 'When disabled, the screen will not show an auto-return countdown, but the "Return to lottery home" button remains available.',
    autoReturnSeconds: 'Auto-return time (seconds)',
    autoReturnSecondsSuffix: 'seconds until return',
    autoReturnSecondsPlaceholder: 'Enter 1-3600 seconds',
    autoReturnSecondsInvalid: 'Auto-return time must be between 1 and 3600 seconds',
    effectHint: 'Motion: guests enter one by one, 3D rotation or matrix scrolling, reveal spotlight and confetti. Devices with reduced motion enabled use simplified animations.',
    save: 'Save design',
    saving: 'Saving…',
    saveSuccess: 'Screen design saved',
    saveFailed: 'Failed to save screen design. Please try again.',
    titleRequired: 'Please enter a main title',
    titlePlaceholder: 'Your big screen title',
    previewPrizeName: 'Lucky prize · Event gift box',
    imageTypeError: 'Only JPG, PNG, or WebP images are supported',
    backgroundSizeError: 'Background image cannot exceed 5 MB',
    logoSizeError: 'Event logo cannot exceed 5 MB',
    previewTitle: 'Page preview',
    previews: {
      screen: 'Lottery screen',
      join: 'Check-in page',
      success: 'Joined successfully'
    },
    sampleNumber: 'A001',
    sampleName: 'Alex Chen',
    previewEmpty: 'No page available to preview',
    openPreview: 'Open lottery screen preview',
    openJoinPreview: 'Open check-in page preview',
    openSuccessPreview: 'Open success page preview',
    previewHint: 'Opens the selected page in a new window.'
  },
  participants: {
    title: 'Participants',
    desc: 'Guests can join after scanning and completing authorization. A check-in record is not required.',
    search: 'Search name / mobile / nickname / lottery number',
    name: 'Name',
    lotteryNumber: 'Lottery number',
    mobile: 'Mobile',
    fixedWinner: 'Fixed prize',
    fixedWinnerPlaceholder: 'Choose a fixed prize for this mobile',
    organization: 'Organization',
    session: 'Session',
    source: 'Source',
    sourceWechat: 'WeChat',
    sourceImport: 'Imported',
    multiRound: 'Sessions',
    onlyOneRound: 'One session only',
    multiRoundOption: 'Multiple sessions',
    allSessions: 'All sessions',
    allSources: 'All sources',
    multiRoundUpdateFailed: 'Unable to update the session setting',
    round: 'Round',
    joinedAt: 'Joined at',
    actions: 'Actions',
    delete: 'Delete',
    deleteConfirm: 'Delete "{name}"? This removes the participant from the current list.',
    deleteSuccess: 'Participant deleted',
    deleteFailed: 'Unable to delete participant',
    empty: 'No participants yet. They will appear after opening the participant page and logging in.',
    total: '{count} participants',
    downloadTemplate: 'Download CSV template',
    importCsv: 'Import CSV list',
    importHint: 'The first row must contain Name and Mobile headers. Both fields are required. An existing participant with the same mobile number will have their name replaced.',
    csvMalformed: 'The CSV file is malformed',
    csvHeaderError: 'CSV headers must include Name and Mobile (or Phone)',
    csvRowError: 'Row {row} has a missing name or invalid mobile number',
    importResult: 'Import complete: {created} added, {updated} replaced'
  },
  winners: {
    title: 'Winner records',
    export: 'Export records',
    session: 'Session',
    roundPrize: 'Prize level',
    prize: 'Prize',
    winner: 'Winner',
    lotteryNumber: 'Lottery number',
    mobile: 'Mobile',
    drawnAt: 'Drawn at',
    claimStatus: 'Claim status',
    claimedAt: 'Claimed at',
    claimed: 'Claimed',
    markClaimed: 'Mark claimed',
    cancelClaimed: 'Undo claim',
    empty: 'No winner records',
    total: '{count} records',
    exportHeaders: {
      session: 'Session',
      round: 'Round',
      prizeLevel: 'Prize level',
      prizeName: 'Prize',
      winner: 'Winner',
      lotteryNumber: 'Lottery number',
      mobile: 'Mobile',
      drawnAt: 'Drawn at',
      claimed: 'Claim status',
      claimedAt: 'Claimed at'
    }
  },
  confirm: {
    startTitle: 'Start a new round',
    startMessage: 'Start “{prize}”? The join window stays open until you select “Roll now.”',
    finishTitle: 'Reveal now',
    finishMessage: 'Finish rolling immediately and generate the winner list?',
    cancelTitle: 'Cancel this round',
    cancelMessage: 'Join records stay, but no winner will be generated. Cancel this round?'
  },
  join: {
    title: 'Join the lucky draw',
    desc: 'Watch the big screen. Your lucky moment could be next.',
    tagWelcome: 'Welcome to your lucky moment',
    tagHeadline: 'Tonight, luck is on your side',
    wechatLoginTitle: 'WeChat authorization',
    wechatLoginIntro: 'Authorize to join this lucky draw',
    wechatPermissionTitle: 'Use your WeChat nickname as the participant name',
    wechatPermissionHint: 'A unique lottery number will be created after authorization',
    wechatButton: 'Authorize with WeChat',
    wechatUnavailable: 'WeChat authorization is not configured. Please contact the event team.',
    mobileTitle: 'Add your mobile number',
    mobileIntro: 'WeChat authorization is complete. Add a mobile number to finish joining.',
    mobileLabel: 'Mobile number',
    mobileHint: 'Only the number format is checked. No SMS verification code is required.',
    mobileFormatError: 'Enter a valid 11-digit mobile number',
    loginExpired: 'Your session has expired. Scan the code again.',
    bindingMobile: 'Binding…',
    finishJoin: 'Finish and join',
    mobileBindFailed: 'Unable to bind the mobile number. Please try again.',
    successNumberLabel: 'Participation number',
    successTitle: 'Joined successfully',
    successMessage: 'You are on the lucky list. Keep an eye on the live screen.',
    blessing: 'May everything you hope for meet you with good fortune',
    loading: 'Connecting to the live draw…',
    wechatLogin: 'Sign in with WeChat',
    loggingIn: 'Signing in…',
    loginHint: 'Your WeChat avatar and nickname will be used only for the live lottery display.',
    identityTitle: 'Complete participation profile',
    identityDesc: 'Enter the name and mobile number used for the lottery.',
    name: 'Name',
    namePlaceholder: 'Enter name',
    mobile: 'Mobile',
    mobilePlaceholder: 'Enter an 11-digit mobile number',
    verify: 'Verify and enter',
    verifying: 'Verifying…',
    manualTitle: 'Local demo login',
    manualHint: 'WeChat authorization is disabled. Enter a name and mobile number to participate.',
    manualNickname: 'Display nickname (optional)',
    welcome: 'Hello, {name}',
    myNumber: 'My lottery number',
    numberHint: 'Keep this number. You will join future rounds automatically.',
    checkinRequired: 'Login failed. Please scan the QR code again.',
    autoJoined: 'You are automatically entered in this round',
    waitTitle: 'Waiting for the host',
    waitDesc: 'Keep this page open. You can join when the next round starts.',
    joinTitle: 'The round is open',
    joinDesc: 'Join now and your avatar will appear on the live screen.',
    joinButton: 'Join now',
    joining: 'Joining…',
    joined: 'You are in. Watch the big screen',
    countdown: '{seconds} seconds left',
    closed: 'The join window has closed',
    rolling: 'The draw is rolling. Watch the big screen',
    winner: 'Congratulations!',
    notWinner: 'No win this round. Try again next round',
    noRound: 'A new round has not started yet',
    disabled: 'The lottery is not open yet',
    notWechat: 'Scan the on-site QR code from WeChat to participate',
    reload: 'Refresh',
    error: 'Unable to connect to the live draw. Please try again.'
  },
  winnerQuery: {
    eyebrow: 'LUCKY MOMENT · WINNER CHECK',
    title: 'Check your result',
    subtitle: 'Enter your mobile number to check results across all sessions',
    queryTitle: 'Check by mobile',
    queryIntro: 'Enter the mobile number used to participate and view winning records from all sessions',
    mobileLabel: 'Mobile number',
    mobilePlaceholder: 'Enter an 11-digit mobile number',
    mobileHint: 'No WeChat authorization required. Used only to match records across all sessions',
    mobileFormatError: 'Enter a valid 11-digit mobile number',
    mobileQueryButton: 'Check winning records',
    mobileQuerying: 'Checking…',
    mobileQueryFailed: 'Unable to query this mobile number. Please try again',
    participant: 'Participant',
    lotteryNumber: 'Number',
    congratulations: 'Congratulations',
    winnerSummary: '{count} winning result(s) in total',
    sessionRound: 'Session {session} · Round {round}',
    claimed: 'Claimed',
    notClaimed: 'To claim',
    noWinTitle: 'No winning record found',
    noWinDesc: 'No winning record was found. Please refer to the live screen for the official result.',
    refreshing: 'Refreshing…',
    refresh: 'Refresh',
    queryAnother: 'Check another mobile',
    disclaimer: 'Results are for reference. The official on-site draw record prevails.'
  },
  screen: {
    eyebrow: 'LIVE LUCKY DRAW',
    waiting: 'Waiting for the next round',
    waitingHint: 'Guests can scan and sign in before the host starts the round',
    scanTitle: 'Scan to join',
    scanHint: 'Sign in with WeChat. Your avatar and nickname will appear on screen',
    participantCount: '{count} guests joined',
    countdownUnit: 'seconds until the join window closes',
    joinedTitle: 'Guests in the draw',
    allGuests: 'All joined guests',
    noParticipants: 'Waiting for guests to scan',
    noEligibleWinners: 'No eligible winners for this round',
    choosePrize: 'Choose the next prize',
    rolling: 'Luck is unfolding',
    rollingHint: 'Keep your eyes on the screen',
    winners: 'Tonight’s lucky guests',
    nextPrize: 'Next prize',
    remaining: '{count} remaining',
    winnersPerRound: '{count} winners per round',
    roundNo: 'Round {round}',
    start: 'Start round',
    roll: 'Roll now',
    finish: 'Reveal now',
    cancel: 'Cancel round',
    soundOn: 'Sound on',
    soundOff: 'Sound off',
    tapToEnableSound: 'Tap to enable sound',
    returnHomeIn: 'Returning to the lottery home in {seconds}s · Tap to return now',
    returnHome: 'Return to lottery home',
    adminOnly: 'Screen controls',
    fullscreen: 'Fullscreen',
    error: 'Unable to load screen state',
    retry: 'Reconnect',
    idlePrize: 'Prize coming up',
    winnerQueryEyebrow: 'WINNER CHECK',
    winnerQueryTitle: 'Scan to check results',
    winnerQueryHint: 'Enter your participation mobile number to check winning records from all sessions'
  }
}
